import styled from 'styled-components'

export const FormContainer = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 500px;
  margin: auto;
`

export const Label = styled.label`
  font-weight: bold;
  margin-top: 10px;
  display: block;
`

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin: 5px 0 15px;
  border-radius: 6px;
  border: 1px solid #ccc;
`

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  height: 120px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
`

